"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
exports.Content = (0, flora_react_1.styled)(flora_react_1.Flex, {
    flexDirection: 'column',
    alignItems: 'center',
    gap: '$2',
});
